import { render, staticRenderFns } from "./viewPendingDis.vue?vue&type=template&id=33f2e060"
import script from "./viewPendingDis.vue?vue&type=script&lang=js"
export * from "./viewPendingDis.vue?vue&type=script&lang=js"
import style0 from "./viewPendingDis.vue?vue&type=style&index=0&id=33f2e060&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports